<template>
    <div>
        <spinner></spinner>
        <v-login></v-login>
        <v-suspended></v-suspended>
        <q-layout :view="layout">

            <!-- Navbar -->
            <q-layout-header>
                <v-header @rightDrawerToogle="right = !right"></v-header>
            </q-layout-header>

            <!-- Right Side Panel -->
            <q-layout-drawer side="right" v-model="right" behavior="mobile">
                <v-menu></v-menu>
            </q-layout-drawer>

            <!-- Content -->
            <q-page-container>
                <router-view/>
            </q-page-container>

            <!-- Navbar -->
            <q-layout-footer>
                <v-footer></v-footer>
            </q-layout-footer>

        </q-layout>
    </div>
</template>

<script>
import VHeader from "../components/Header";
import VMenu from "../components/Menu";
import VFooter from "../components/Footer";
import VLogin from "../pages/auth/login";
import VSuspended from "../pages/auth/suspended";

import {
  QLayout,
  QLayoutHeader,
  QLayoutDrawer,
  QLayoutFooter,
  QPageContainer
} from "quasar-framework";

export default {
  name: "MainLayout",

  components: {
    VHeader,
    VMenu,
    VFooter,
    VLogin,
    QLayout,
    VSuspended,
    QLayoutHeader,
    QLayoutDrawer,
    QLayoutFooter,
    QPageContainer
  },

  data() {
    return {
      right: false
    };
  },

  computed: {
    layout() {
      if (this.$breakpoints.isGreaterThan("sm")) return "lhr lpr lFr";
      return "lHr lpr lFr";
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/layouts/default.vue